export const TABLE_SIZE = 15;
export const SKELETON_HEIGHT = 62.06;
export const SEARCH_INPUT_WIDTH = "280px";
export const PROCEDURE_SKELETON_BORDER_RADIUS = "0px";
